import React from 'react'
import { Button } from 'antd'
import { legalAgeTemplateDocLink } from '../../../../Constants'

const btnStyle = {
  borderRadius: '7px'
}

function LegalAgeTemplateButton () {
  return (
    <Button
      block
      size='large'
      style={btnStyle}
      className='margin-bottom-20'
    >
      <a href={legalAgeTemplateDocLink} target='_blank' rel='noreferrer'>
        <img src='/img/download-icon.png' style={{ marginRight: '0.5rem' }} />
        Скачать шаблон согласия
      </a>
    </Button>
  )
}

export default LegalAgeTemplateButton
